import { DOMNode, Comment } from "html-react-parser"

export default function isComment(domNode: DOMNode): domNode is Comment {
  return domNode.type === `comment`
}
